function ErrorMessage({ error, onDismiss }) {
  if (!error) return null;
  
  return (
    <div className="w-full max-w-2xl mb-4 p-3 bg-red-100 text-red-600 border border-red-300 rounded-lg flex items-start justify-between">
      <div className="flex items-start">
        <svg className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <div>
          <h3 className="font-semibold text-red-700">Error</h3>
          <p>{typeof error === 'string' ? error : error.message || 'Something went wrong'}</p>
        </div>
      </div>
      {onDismiss && (
        <button 
          onClick={onDismiss}
          className="ml-3 text-red-500 hover:text-red-700"
        >
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
}

export default ErrorMessage; 